const carouselItems = [
  {
    title: '暗夜追踪：年度动作巨制',
    desc: '顶级特工深入敌后，一场关乎生死的猫鼠游戏在高楼林立的都市丛林中激烈上演。全程高能无尿点，动作场面实拍为主。',
    image: 'https://readdy.ai/api/search-image?query=Intense%20action%20movie%20scene%20with%20silhouetted%20figure%20on%20rooftop%20at%20night%2C%20city%20skyline%20with%20neon%20lights%2C%20dramatic%20cinematic%20lighting%2C%20dark%20moody%20atmosphere%2C%20film%20noir%20style%2C%20professional%20movie%20poster%20aesthetic&width=600&height=400&seq=carousel-01&orientation=landscape',
    tag: '热播推荐',
  },
  {
    title: '星河战纪第三季回归',
    desc: '星际联盟与外星文明之间的史诗级战争进入白热化阶段，全新角色登场，视觉特效全面升级，本季共24集连播。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20battle%20with%20massive%20starships%20and%20colorful%20nebula%20background%2C%20laser%20beams%20and%20explosions%2C%20cinematic%20wide%20shot%2C%20dramatic%20and%20immersive%20visual%20effects%2C%20professional%20movie%20poster%20quality&width=600&height=400&seq=carousel-02&orientation=landscape',
    tag: '剧集追踪',
  },
  {
    title: '都市寓言：治愈系爱情',
    desc: '在繁华都市的某个角落，两个孤独灵魂因一次偶然相遇开始了一段温暖治愈的旅程，年度最高分国产爱情电影。',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20couple%20walking%20through%20rainy%20city%20street%20at%20sunset%2C%20warm%20golden%20light%20reflections%20on%20wet%20pavement%2C%20cinematic%20depth%20of%20field%2C%20intimate%20and%20emotional%20mood%2C%20film%20photography%20aesthetic&width=600&height=400&seq=carousel-03&orientation=landscape',
    tag: '高分推荐',
  },
  {
    title: '迷雾深渊：烧脑悬疑新片',
    desc: '一座与世隔绝的海岛度假村接连发生离奇事件，十位客人中藏着一位不为人知的危险人物，反转再反转的叙事结构。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20foggy%20island%20lighthouse%20at%20dusk%2C%20dark%20brooding%20sky%2C%20solitary%20figure%20standing%20on%20rocky%20shore%2C%20suspenseful%20atmosphere%2C%20cinematic%20thriller%20aesthetic%2C%20film%20noir%20lighting&width=600&height=400&seq=carousel-04&orientation=landscape',
    tag: '悬疑精选',
  },
  {
    title: '笑闹江湖：功夫喜剧回归',
    desc: '一群身怀绝技却各怀鬼胎的江湖人士意外卷入一场荒诞冒险，全程笑料百出，动作设计精彩绝伦，老少皆宜。',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20traditional%20Chinese%20martial%20arts%20scene%20with%20dynamic%20action%20pose%2C%20vibrant%20costumes%2C%20ancient%20temple%20courtyard%20background%2C%20cinematic%20lighting%2C%20energetic%20and%20playful%20mood%2C%20professional%20film%20still&width=600&height=400&seq=carousel-05&orientation=landscape',
    tag: '喜剧专场',
  },
  {
    title: '长安风云录：年度古装大剧',
    desc: '大唐盛世背后暗流涌动，朝堂权谋与江湖恩怨交织，实力派演员阵容倾情演绎一段波澜壮阔的历史传奇。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20interior%20with%20ornate%20golden%20decorations%2C%20soft%20candlelight%20illuminating%20silk%20robes%2C%20historical%20drama%20atmosphere%2C%20rich%20warm%20colors%2C%20cinematic%20composition%2C%20elegant%20and%20majestic&width=600&height=400&seq=carousel-06&orientation=landscape',
    tag: '重磅上线',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 whitespace-nowrap">精选专题</span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">焦点专题 · 重磅推荐</h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-lg mx-auto">编辑团队为你精选的优质影视内容，每一部都值得花时间观看</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item, i) => (
            <div key={i} className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer">
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-semibold whitespace-nowrap">{item.tag}</span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-semibold text-sm md:text-base text-foreground-900 mb-2 font-heading">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}